<template>
  <div class="muji-review__count">
    <ul v-if="!isGlobalError && !isRenderNoneMessage && isRenderBaseReviewSummary" >
      <li class="review__item__rating">
        <span class="star-wrap star-size-14"><span :class="averageNumber | formatRatingClassName('star-')">{{ averageNumber | formatRating }}</span></span>
      </li>
      <li class="review__item__count"><a :href="itemReviewUrl"><span>{{ itemAdditionalInfo.count }}</span>件のレビュー</a>が投稿されています</li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import urls from '@/mixins/urls'
import loadings from '@/mixins/loadings'
import errors from '@/mixins/errors'
export default {
  name: 'BaseReviewSummary',
  mixins: [ urls, loadings, errors ],
  computed: {
    ...mapGetters({
      count: 'storeReviews/count',
      itemAdditionalInfo: 'storeReviews/itemAdditionalInfo',
      targetSku: 'storeReviews/targetSku',
      linkTargetSku: 'storeReviews/linkTargetSku'
    }),
    averageNumber () {
      return Math.round(Number(this.itemAdditionalInfo.average) * 10) / 10
    },
    isRenderBaseReviewSummary () {
      return (this.itemAdditionalInfo.average && this.itemAdditionalInfo.count)
    },
    itemReviewUrl () {
      return this.getItemReviewUrl(this.linkTargetSku)
    },
    itemImageUrl () {
      return this.getItemImageUrl(this.targetSku)
    },
    reviewImageUrl () {
      return this.getReviewImageUrl(this.targetSku)
    },
    reviewPostUrl () {
      return this.getReviewPostUrl(this.targetSku, 'isDetail')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BaseReviewSummary.vue